import { StyledNavbar } from '../StyledNavbar/StyledNavbar.js';
import { type Footer_userProfile$key } from '@/__generated__/relay/Footer_userProfile.graphql.js';
import { Footer } from '@/components/Footer/Footer.js';
import { FooterLinks } from '@/components/Footer/Footer.styles.js';
import { Layout } from '@/components/Layout/Layout.js';
import { Section } from '@/components/Section/Section.js';
import { Body } from '@/components/Typography/Body.js';
import { useUserProfile } from '@/hooks/useUserProfile.js';
import { styled } from '@/stitches/index.js';
import { type ReactNode } from 'react';

const StyledFooter = styled(Footer, {
  [`${FooterLinks}`]: {
    gap: '$32',
  },
  '& *': {
    fontSize: '$16',
    fontWeight: '$medium',
    letterSpacing: '$1',
  },
});

export const BaseLayout = ({
  children,
  queryRef,
}: {
  readonly children: ReactNode;
  readonly queryRef: Footer_userProfile$key;
}) => {
  const userProfile = useUserProfile();

  if (!userProfile) return null;

  const { firstName, lastName } = userProfile;
  const fullName = `${firstName} ${lastName}`;

  return (
    <Layout>
      <Layout.ScrollableChildWithPadding
        alignLinks="end"
        as={StyledNavbar}
        finalLink="recommendations"
        logoSlot={<Body as="h5">{fullName}</Body>}
        workWithMeLabel="Work With Me"
        workWithMeSolidBg={false}
      />
      {children}
      <Section margin="y">
        <StyledFooter
          finalLink="recommendations"
          queryRef={queryRef}
        />
      </Section>
    </Layout>
  );
};
